import React from 'react'
import './style.scss'

export default () => {
  return (
    <section className="loading">
      <div className="loading__overlay">
        <img
          src="/parcerias/assets/loading.svg"
          alt="Carregando"
          className="loading__icon"
        />
      </div>
    </section>
  )
}
